import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/services/common.service';
import { ReviewService } from 'src/app/services/common/review.service';
import { UserService } from 'src/app/services/user.service';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import * as _ from 'lodash';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-documentreview',
  templateUrl: './documentreview.component.html',
  styleUrls: ['./documentreview.component.scss']
})
export class DocumentreviewComponent implements OnInit {

  Content: any;
  allFiles: any;
  heading : string;
  reviewId: string;
  applicationId: string;
  applicationCode: string;
  allFilesCopy: any;
  module: string;

  constructor(  
    public modalRef: NgbActiveModal,
    public modalRf: NgbActiveModal,
    private commonService: CommonService,
    private modalService: NgbModal,
    private userService: UserService,
    private reviewService: ReviewService,
    private loaderService: LoaderService
  ) {
   
  }
  
  ngOnInit() {      
    if (this.Content !== null) {
      //this.allFiles = this.Content.content.reviewDocs;
      this.allFilesCopy = _.cloneDeep(this.Content.content.reviewDocs);
      this.reviewId = this.Content.content.ReviewId;
      this.applicationId = this.Content.content.applicationId;
      this.applicationCode = this.Content.content.applicationCode;
      this.heading = this.Content.heading;
      this.module = this.Content.content.module;
    }

    this.GetReviewDocuments();
   }
   GetReviewDocuments(){
      this.reviewService.GetReviewDocuments("api/Review/GetReviewDocuments?ReviewId=" + this.reviewId).subscribe((result: any[] )=> {
        if (result) {
          if(this.heading == "Start"){
            this.allFiles = result.filter(x=> x.Status == "Start");               
          }
  
          if(this.heading == "Update"){
            this.allFiles = result.filter(x=> x.Status == "Update" || x.Status == "Start");   
          }
          
          if(this.heading == "Complete"){
            this.allFiles = result.filter(x=> x.Status == "Update" || x.Status == "Complete");   
          }
        }
      });  
   }
   

   review(doc: any){
    let formData = { "ReviewId":this.reviewId ,"ReviewDocId": doc.FileID, "ApplicationCode": this.applicationCode, DocStatus: doc.Status }; 
    let modalRefe;
    if(doc.Status == "Start"){
      this.reviewService.UpdateDocReviewerStatus("api/Review/UpdateDocReviewerStatus", formData).subscribe((result)=> {
        if (result) {          
          this.commonService.OnlyOfficePopupLanch(doc.FileID, this.reviewId, this.allFiles, this.applicationCode).subscribe(async res=>{
            this.reviewService.GetReviewDocuments("api/Review/GetReviewDocuments?ReviewId=" + this.reviewId).subscribe((result: any[] )=> {
              let files;
              if (result) {
                if(this.heading == "Start"){
                  files = result.filter(x=> x.Status == "Start");               
                }
        
                if(this.heading == "Update"){
                  files = result.filter(x=> x.Status == "Update" || x.Status == "Start");   
                }
                
                if(this.heading == "Complete"){
                  files = result.filter(x=> x.Status == "Update" || x.Status == "Complete");   
                }
              }
              this.allFiles = files;
              if(files.length == 0){               
                this.modalRef.close();
              }
            });  
          }); 
        }
      });         
    } 

     if (doc.Status == "Update" && this.heading == "Update") {
       this.commonService.OnlyOfficePopupLanch(doc.FileID, this.reviewId, this.allFiles, this.applicationCode).subscribe(res => {
         this.loaderService.isLoading.next(true);         
         setTimeout(async () => {
           if (res != null) {
            //  this.commonService.CompleteReviewDocStatus("api/Review/ReviewDocUniqueKey?ConfigId=" + res + '&ReviewId=' + this.reviewId).subscribe(result => {
            //  });
             this.reviewService.GetReviewDocuments("api/Review/GetReviewDocuments?ReviewId=" + this.reviewId).subscribe((result: any[] )=> {
              let files;
              if (result) {
                if(this.heading == "Start"){
                  files = result.filter(x=> x.Status == "Start");               
                }
        
                if(this.heading == "Update"){
                  files = result.filter(x=> x.Status == "Update" || x.Status == "Start");   
                }
                
                if(this.heading == "Complete"){
                  files = result.filter(x=> x.Status == "Update" || x.Status == "Complete");   
                }
              }
              this.allFiles = files;
              if(files.length == 0){               
                this.modalRef.close();
              }
            });
           }
         }, 20000);
       });
     }

    if(doc.Status == "Update" && this.heading == "Complete"){       
      let modalRefe1= this.modalService.open(DeleteBoxComponent, { backdrop: false });
      modalRefe1.componentInstance.Content = { heading: 'Confirmation', custommessage: 'You are about to complete the Review for ' + doc.FileName + '; do you want to proceed?', ProceedButtonName: "Confirm", TerminateButtonName: "Cancel" };
      modalRefe1.result.then(result => {
        if (result == "okclick") {
          this.reviewService.UpdateDocReviewerStatus("api/Review/UpdateDocReviewerStatus", formData).subscribe((result)=> {
            if (result) {
              this.commonService.SuccessBanner('Review completed successfully');
              this.GetReviewDocuments();
            }
          });
        }
      });
    }    
   }

   close(){
    this.modalRef.close(this.module);
   }
}
